import AWS from 'aws-sdk'
import { Auth } from 'aws-amplify'

export type UserAttributes = AWS.CognitoIdentityServiceProvider.AttributeListType

export interface CognitoIdentityServiceProvider {
  adminGetUser (params: AWS.CognitoIdentityServiceProvider.AdminGetUserRequest): Promise<AWS.CognitoIdentityServiceProvider.AdminGetUserResponse>
  adminUpdateUserAttributes (params: AWS.CognitoIdentityServiceProvider.AdminUpdateUserAttributesRequest): Promise<AWS.CognitoIdentityServiceProvider.AdminUpdateUserAttributesResponse>
}

export class AuthCognitoIdentityServiceProvider implements CognitoIdentityServiceProvider {
  async adminGetUser (params: AWS.CognitoIdentityServiceProvider.AdminGetUserRequest): Promise<AWS.CognitoIdentityServiceProvider.AdminGetUserResponse> {
    return (await this.getInstance()).adminGetUser(params).promise()
  }

  async adminUpdateUserAttributes (params: AWS.CognitoIdentityServiceProvider.AdminUpdateUserAttributesRequest): Promise<AWS.CognitoIdentityServiceProvider.AdminUpdateUserAttributesResponse> {
    return (await this.getInstance()).adminUpdateUserAttributes(params).promise()
  }

  private async getInstance () {
    try {
      let cred = await Auth.currentUserCredentials()
      return new AWS.CognitoIdentityServiceProvider({
        region: 'ap-northeast-1',
        credentials: Auth.essentialCredentials(cred)
      })
    } catch (e) {
      throw e
    }
  }
}
